import {
  ChangeDetectorRef,
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter,  MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTabGroup} from '@angular/material/tabs';
import {Select, Store} from '@ngxs/store';

import {BehaviorSubject, Observable, Subject} from 'rxjs';

import {UserConfigurationMetaData} from '../../../../core/models/user/users-query-result';

import {UsersSelectors} from '../../../../core/store/users/users.selectors';
import {CommonService} from '../../../../services/common.service';

import {Router} from '@angular/router';
import {EventAlert} from '../../../../core/models/events/event-interface';
import {EventsService} from '../../../../core/services/events.service';
import {ConfirmationService} from 'primeng/api';
import { TicksToDateService } from 'src/app/core/services/ticks-to-date.service';
import {first, takeUntil} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import UuidHelper from '../../../../services/uuid.helper';



@Component({
  selector: 'app-event-dismiss',
  templateUrl: './event-dismiss.component.html',
  styleUrls: ['./event-dismiss.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]}]
})
export class EventDismissComponent implements OnInit, OnDestroy {

  @Select(UsersSelectors.getPermissions) permissions$: Observable<any>;
  @Select(UsersSelectors.configuration) configuration: BehaviorSubject<UserConfigurationMetaData>;

  @ViewChild('tabIndexes') tabIndexes: MatTabGroup;

  private destroy$ = new Subject<boolean>();

  isLoading: boolean = false;

  eventItem: EventAlert = null;

  discussionText: string = '';
  time: Date = null;

  private remove: string;
  private update: string;
  private continue: string;

  constructor(public dialogRef: MatDialogRef<EventDismissComponent>,
              public commonService: CommonService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private ngZone: NgZone, private store: Store,
              private snackBar: MatSnackBar, private ref: ChangeDetectorRef,
              private router: Router,
              private readonly eventsService: EventsService,
              private confirmationService: ConfirmationService,
              private ticksToDateService: TicksToDateService,
              public translate: TranslateService) {
    this.translate.get([
      `Events.table.dismissPopup.remove`,
      `Events.table.dismissPopup.continue`,
      `Events.table.dismissPopup.update`,
    ]).pipe(first()).subscribe((res: string) => {
      this.remove = res[`Events.table.dismissPopup.remove`];
      this.update = res[`Events.table.dismissPopup.update`];
      this.continue = res[`Events.table.dismissPopup.continue`];
    });
  }

  popupKey = '';

  ngOnInit(): void {
    this.popupKey = `alarm-${UuidHelper.create_UUID().slice(0,8)}`;
    this.eventItem = this.data.eventItem;
    this.time = this.data.eventItem.alarm ? this.ticksToDateService.ticksToDate(this.data.eventItem.alarm.remarkInfo.alarmDate) : null;

    this.discussionText = this.data.eventItem.alarm?.remarkInfo?.discussion;

    this.permissions$
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result && !result.action.permissions.events.modify) {
          this.router.navigate(['/not-found']);
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  dismissClick() {

    const alertId = this.eventItem.alarm?.remarkInfo ? this.eventItem.alarm.remarkInfo.alertId : null;

    let headerText: string;
    let acceptMethod;

    if (this.discussionText === '') {
      headerText = this.remove;

      acceptMethod = () => {
        const eventData = {eventData : {alertId}};
        this.eventsService.deleteAlert(eventData).then( () => {
          this.eventItem.alarm = null;
          this.dialogRef.close();
        });
        this.confirmationService.close();
      };
    } else {
      headerText = this.update;

      acceptMethod = () => {
        const eventData = {
          eventData: {
            message: this.discussionText,
            eventId: this.eventItem.alarm.remarkInfo.eventId,
            alertId
          }
        };
        this.eventsService.updateAlert(eventData).then(r => {
          if (r?.upsertAlertDismiss === true) {

            if (!this.eventItem.alarm) {

              this.eventItem.alarm = {
                eventGeneratorId: 'string',
                eventLocationId: 'string',
                remarkInfo: {
                  alertId: 0,
                  eventId: this.eventItem.id as unknown as number,
                  description: '',
                  discussion: this.discussionText,
                  links: '',
                  alarmDate: this.eventItem.time,
                }
              };
            } else {
              this.eventItem.alarm.remarkInfo.discussion = this.discussionText;
            }

            this.dialogRef.close();
          }
        });
        this.confirmationService.close();
      };
    }

    this.confirmationService.confirm({
      key: this.popupKey,
      header: headerText,
      message: this.continue,
      accept: acceptMethod,
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  minimizeDialog() {
    this.dialogRef.addPanelClass('hide');
    this.eventsService.onScreenDialog.next(false);
  }
}
